import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { MODAL_TYPE, SL_FORM_TITLE } from 'Defaults/modals'
import { getGoogleClickId } from 'Hooks/useGoogleAdsGclid'
import { getGoogleUtmObj } from 'Hooks/useGoogleUtm'
import { generateRecaptchaToken } from 'Utils/recaptchaUtils'
// import { saveCredential } from 'Utils/biometricsUtils'
import {
  GOOGLE_UTM_CAMPAIGN,
  GOOGLE_UTM_MEDIUM,
  GOOGLE_UTM_SOURCE,
  GOOGLE_UTM_TERM,
} from 'Defaults/googleAds'
import SSOSignup from './SSOSignup'

import Login from './Login'
import ExclusiveFeatures from './ExclusiveFeatures'

// import css from './styles.js'
import {
  _SignupWrap,
  _LoginModal,
  _LoginForm,
  _SignupForm,
  _SwitchToSignup,
} from './styles'

class LoginModal extends Component {
  constructor(props) {
    super(props)
    const isInitialSignupForm = props.tabId === 1

    const emailInputValStep1 = props.emailInputValStep1 || ''
    this.state = {
      selectedIndex: props.tabId,
      // loginInputVal: '',
      // passwordInputVal: '',
      firstInputVal: props.firstInputVal || '',
      lastInputVal: props.lastNameVal || '',
      emailInputVal: emailInputValStep1,
      signupPasswordVal: '',
      phoneInputVal: props.phoneInputVal || '',
      phoneCountryCode: props.phoneCountryCode || null,
      isNewsletterSubscribe: false,
      iAmAgent: false,
      iAmAgentClickedOnce: false,
      loginMainError: props.loginMainError || '',
      isInitialSignupForm,
      isLoadingRecaptcha: false,
    }
    this.signupInputsUpdate = this.signupInputsUpdate.bind(this)
    this.newsletterCheckboxesUpdate = this.newsletterCheckboxesUpdate.bind(
      this,
    )
    this.setLoadingRecaptchaStatus = this.setLoadingRecaptchaStatus.bind(this)
    this.iAmAgentCheckbox = this.iAmAgentCheckbox.bind(this)
    this.openPassReset = this.openPassReset.bind(this)
    this.doSignupStep2 = this.doSignupStep2.bind(this)
  }

  componentDidMount() {
    if(this.props.signupStep !== 2) {
      const category = this.props.tabId === 1 ? 'login' : 'register'
      this.props.googleAnalyticsEvent({
        category,
        action: ['Show', `From ${this.props.modalSource}`],
        label: this.props.modalSource,
      })
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.tabId !== prevProps.tabId) {
      this.setState({ selectedIndex: this.props.tabId })
    }
    // if an account exists with input email on signup switch to login modal and let user login
    if(
      this.props.userDataErrors &&
      this.props.userDataErrors.signupErrors &&
      this.props.userDataErrors.signupErrors.email_exists &&
      !(prevProps.userDataErrors && prevProps.userDataErrors.signupErrors)
    ) {
      if(!this.props.listingCard) {
        // eslint-disable-next-line
        this.setState({
          selectedIndex: 1,
          loginMainError: this.props.userDataErrors.signupErrors.email_exists,
        })
      } else {
        const {
          emailInputValStep1,
          gate,
          openModal,
          userDataErrors,
        } = this.props
        openModal({
          modalType: MODAL_TYPE.LOGIN,
          modalData: {
            emailInputValStep1,
            gate,
            loginMainError: userDataErrors.signupErrors.email_exists,
          },
        })
      }
    }
  }

  handleTabSelect(index) {
    // e.preventDefault()

    this.setState({
      // signupStep: 1,
      selectedIndex: index,
      firstInputVal: '',
      lastInputVal: '',
      // emailInputVal: '',
      phoneInputVal: '',
      phoneCountryCode: '',
    })

    if(index === 0 && !this.state.isInitialSignupForm) {
      this.props.googleAnalyticsEvent({
        category: 'register',
        action: '[Show]',
        label: this.props.modalSource,
      })
      this.setState({ isInitialSignupForm: true })
    }
  }

  setLoadingRecaptchaStatus(loading) {
    this.setState({ isLoadingRecaptcha: loading })
  }

  openPassReset() {
    this.props.openModal({ modalType: MODAL_TYPE.RESET_PASSWORD })
    this.props.googleAnalyticsEvent({
      category: 'login',
      action: '[Forgot password]',
    })
  }

  // /////// SIGNUP /////////
  signupInputsUpdate(inputData) {
    const inputId = inputData.id
    const inputVal = inputData.value

    if(inputData.phone) {
      this.setState({
        phoneInputVal: inputData.phone,
        phoneCountryCode: inputData.code,
      })
    }

    switch(inputId) {
      case 'first':
        this.setState({ firstInputVal: inputVal })
        break
      case 'last':
        this.setState({ lastInputVal: inputVal })
        break
      case 'email':
        this.setState({ emailInputVal: inputVal })
        break
      case 'signup_password':
        this.setState({ signupPasswordVal: inputVal })
    }
  }

  newsletterCheckboxesUpdate(event) {
    const checked = event.target.checked
    this.setState({ isNewsletterSubscribe: checked })
    this.props.googleAnalyticsEvent({
      category: 'register',
      action: ['News letter', checked ? 'Check' : 'UnCheck'],
      label: this.props.modalSource,
    })
  }
  iAmAgentCheckbox(event) {
    const checked = event.target.checked
    this.setState({ iAmAgent: checked })
    if(!this.state.iAmAgent) {
      this.setState({
        iAmAgentClickedOnce: true,
      })
    }
    this.props.googleAnalyticsEvent({
      category: 'register',
      action: ['I am agent Click', checked ? 'Check' : 'UnCheck'],
      label: this.props.modalSource,
    })
  }

  doSignupStep1 = e => {
    e.preventDefault()
    this.props.googleAnalyticsEvent({
      category: 'register',
      action: '[Submit Signup Step1]',
      label: this.props.modalSource,
    })
    const signUpStep1Parameters = { email: this.state.emailInputVal }

    generateRecaptchaToken(
      'submitSignUpStep1',
      this.setLoadingRecaptchaStatus,
      this.props.userCheckEmail,
      signUpStep1Parameters,
    )
  }

  doSignupStep2 = e => {
    e.preventDefault()

    const {
      firstInputVal,
      lastInputVal,
      emailInputVal,
      phoneInputVal,
      phoneCountryCode,
      isNewsletterSubscribe,
      signupPasswordVal,
    } = this.state

    const obj = {
      first_name: firstInputVal,
      last_name: lastInputVal,
      email: emailInputVal,
      phone: phoneInputVal,
      phone_country_code: phoneCountryCode,
      password: signupPasswordVal,
      gate: this.props.gate,
      hasMobileApp: Boolean(this.props.isMobileApp),
    }

    // this part used to trigger ga event on signup success
    if(this.state.iAmAgentClickedOnce) {
      obj.iAmAgentClickedOnce = this.state.iAmAgentClickedOnce
    }
    if(isNewsletterSubscribe) {
      obj.newsletter_subscribe = isNewsletterSubscribe
    }

    if(this.props.completeAccountSubmit) {
      this.props.completeAccountSubmit(obj)
    } else {
      const googleClickId = getGoogleClickId()
      if(googleClickId) {
        obj.googleClickId = googleClickId
      }
      const googleUtmObj = getGoogleUtmObj()
      if(googleUtmObj) {
        obj[GOOGLE_UTM_CAMPAIGN] = googleUtmObj[GOOGLE_UTM_CAMPAIGN]
        obj[GOOGLE_UTM_MEDIUM] = googleUtmObj[GOOGLE_UTM_MEDIUM]
        obj[GOOGLE_UTM_SOURCE] = googleUtmObj[GOOGLE_UTM_SOURCE]
        obj[GOOGLE_UTM_TERM] = googleUtmObj[GOOGLE_UTM_TERM]
      }

      this.props.googleAnalyticsEvent({
        category: 'register',
        action: '[Submit Signup Step2]',
        label: this.props.modalSource,
      })

      const { userCurrentArea } = this.props
      if(userCurrentArea && userCurrentArea.areaType) {
        obj.area_id = userCurrentArea.areaId
        obj.area_type = userCurrentArea.areaType
      }

      this.props.userDoSignup(obj)

      // if(this.props.isMobileApp) {
      //   saveCredential({ username: emailInputVal, password: signupPasswordVal })
      // }
    }
  }
  // /////// END SIGNUP /////////

  render() {
    const {
      signupStep,
      userDataErrors,
      userDataIsFetching,
      listingCard,
      openModal,
      resetSignupProcess,
      gate,
      loginPage,
      modalType,
      hasDelivraAccount,
      modalSource,
      googleAnalyticsEvent,
      isMobileApp,
      completeAccount,
      showGoogleSSO = false,
      SSOUserInfo,
      userCurrentArea,
    } = this.props
    const { signupErrors, loginError } = userDataErrors
    const {
      firstInputVal,
      lastInputVal,
      selectedIndex,
      emailInputVal,
      isNewsletterSubscribe,
      loginMainError,
      phoneInputVal,
      phoneCountryCode,
      isLoadingRecaptcha,
    } = this.state

    const formTitle = gate && SL_FORM_TITLE[gate] ? SL_FORM_TITLE[gate] : ''
    const isLoginModalOpen =
      modalType === MODAL_TYPE.REGISTER || modalType === MODAL_TYPE.LOGIN
    const isListingLoginCardHidden = isLoginModalOpen && listingCard
    return (
      <_LoginModal hidden={isListingLoginCardHidden} listingCard={listingCard}>
        { showGoogleSSO ?
          <SSOSignup
            errors={signupErrors}
            userDataIsFetching={userDataIsFetching}
            openModal={openModal}
            resetSignupProcess={resetSignupProcess}
            gate={gate}
            hasDelivraAccount={hasDelivraAccount}
            modalSource={modalSource}
            googleAnalyticsEvent={googleAnalyticsEvent}
            listingCard={listingCard}
            loginPage={loginPage}
            data-test-id={'signupForm'}
            completeAccount={completeAccount}
            isLoadingRecaptcha={isLoadingRecaptcha}
            SSOUserInfo={SSOUserInfo}
            userGoogleSignup={this.props.userGoogleSignup}
            userCurrentArea={userCurrentArea}
            isMobileApp={isMobileApp}
          /> : selectedIndex === 0 ? (
            <_SignupWrap listingCard={listingCard} loginPage={loginPage}>
              {!loginPage && <ExclusiveFeatures listingCard={listingCard} />}
              <_SignupForm
                step={signupStep}
                checkboxUpdate={this.newsletterCheckboxesUpdate}
                isNewsletterSubscribe={isNewsletterSubscribe}
                iAmAgentCheckboxUpdate={this.iAmAgentCheckbox}
                iAmAgent={this.state.iAmAgent}
                inputsUpdate={this.signupInputsUpdate}
                onSignupStep1={this.doSignupStep1}
                onSignupStep2={this.doSignupStep2}
                errors={signupErrors}
                userDataIsFetching={userDataIsFetching}
                openModal={openModal}
                emailInputValStep1={emailInputVal}
                resetSignupProcess={resetSignupProcess}
                formTitle={formTitle}
                switchToLogin={this.handleTabSelect.bind(this, 1)}
                gate={gate}
                firstNameVal={firstInputVal}
                lastNameVal={lastInputVal}
                phoneVal={{ 'phone_country_code': phoneCountryCode, 'phone': phoneInputVal }}
                hasDelivraAccount={hasDelivraAccount}
                modalSource={modalSource}
                googleAnalyticsEvent={googleAnalyticsEvent}
                listingCard={listingCard}
                loginPage={loginPage}
                data-test-id={'signupForm'}
                completeAccount={completeAccount}
                isLoadingRecaptcha={isLoadingRecaptcha}
                isMobileApp={isMobileApp}
              />


            </_SignupWrap>
          ) : (
            <_LoginForm loginPage={loginPage}>
              <Login
                isMobileApp={isMobileApp}
                onLogin={this.props.doLogin}
                loginPage={loginPage}
                onPassReset={this.openPassReset}
                errorMessage={loginError}
                userDataIsFetching={userDataIsFetching}
                listingCard={listingCard}
                formTitle={formTitle}
                loginMainError={loginMainError}
                data-test-id={'loginForm'}
              />
              <_SwitchToSignup
                data-test-id={'switchToSignup'}
                onClick={this.handleTabSelect.bind(this, 0)}
              >
                Create an Account
              </_SwitchToSignup>
            </_LoginForm>
          )}
      </_LoginModal>
    )
  }
}
LoginModal.defaultProps = {
  userDataErrors: {
    signupErrors: {},
    loginError: '',
  },
}

LoginModal.propTypes = {
  tabId: PropTypes.number.isRequired,
  openModal: PropTypes.func.isRequired,
  doLogin: PropTypes.func.isRequired,
  userCheckEmail: PropTypes.func.isRequired,
  userDoSignup: PropTypes.func.isRequired,
  signupStep: PropTypes.number.isRequired,
  userDataErrors: PropTypes.shape({
    signupErrors: PropTypes.shape({
      email_exists: PropTypes.arrayOf(PropTypes.string),
    }),
    loginError: PropTypes.string,
  }),
  modalSource: PropTypes.string,
  userDataIsFetching: PropTypes.bool,
  listingCard: PropTypes.bool,
  resetSignupProcess: PropTypes.func.isRequired,
  modalType: PropTypes.string,
  emailInputValStep1: PropTypes.string,
  userCurrentArea: PropTypes.shape({
    areaType: PropTypes.string,
    areaId: PropTypes.number,
  }),
  googleAnalyticsEvent: PropTypes.func.isRequired,
  gate: PropTypes.string,
  loginPage: PropTypes.bool,
  loginMainError: PropTypes.string,
  firstInputVal: PropTypes.string,
  lastNameVal: PropTypes.string,
  phoneInputVal: PropTypes.string,
  phoneCountryCode: PropTypes.string,
  hasDelivraAccount: PropTypes.bool,
  isMobileApp: PropTypes.bool,
  completeAccount: PropTypes.bool,
  completeAccountSubmit: PropTypes.func,
  completeAccountErrors: PropTypes.shape({
    signupErrors: PropTypes.shape({
      first_name: PropTypes.arrayOf(PropTypes.string),
      last_name: PropTypes.arrayOf(PropTypes.string),
      email: PropTypes.arrayOf(PropTypes.string),
      phone: PropTypes.arrayOf(PropTypes.string),
      phone_country_code: PropTypes.arrayOf(PropTypes.string),
    }),
  }),
  userGoogleSignup: PropTypes.func,
  showGoogleSSO: PropTypes.bool,
  SSOUserInfo: PropTypes.shape({}),
}

export default LoginModal
